// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylus/components/_sliders.styl
// module id = 217
// module chunks = 0